/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    colorTheme = "colorTheme",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.colorTheme]: "light" | "dark";
    };
}

type Props = OwnProps;

export interface BreadcrumbStyles {
    wrapper?: InjectableCss;
}

export const breadcrumbStyles: BreadcrumbStyles = {
    wrapper: {
        css: css`
            &.dark {
                span {
                    color: ${getColor("common.ui5")} !important;
                }

                nav a {
                    &:hover,
                    &:focus {
                        span {
                            color: ${getColor("primary")} !important;
                        }
                    }
                }
            }
            &.light {
                span {
                    color: ${getColor("text.main")} !important;
                }

                nav a {
                    &:hover,
                    &:focus {
                        span {
                            color: ${getColor("primary")} !important;
                        }
                    }
                }
            }
        `,
    },
};

const styles = breadcrumbStyles;

const Breadcrumbs: React.FunctionComponent<Props> = ({ fields }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper} className={fields?.colorTheme === "dark" ? "dark" : "light"}>
            <PageBreadcrumbs />
        </StyledWrapper>
    );
};

const breadcrumbs: WidgetModule = {
    component: Breadcrumbs,
    definition: {
        group: "XNGAGE" as any,
        fieldDefinitions: [
            {
                name: fields.colorTheme,
                editorTemplate: "DropDownField",
                defaultValue: "light",
                fieldType: "General",
                options: [
                    { displayName: "Light", value: "light" },
                    { displayName: "Dark", value: "dark" },
                ],
            },
        ],
    },
};

export default breadcrumbs;
